import {Command} from './common';
import {ORDER_STATUS_ACTIVE,} from '../../components/util/constants';



function createOrderHeaderFromState(state, cmd, id)
{
    //console.log('state.possibleTexts',state.possibleTexts);
    let orderTexts=state.possibleTexts.filter(t=>t.SELECTED==1).map(t=>{
        return {
            ORDER_NUMBER: cmd==Command.Modify ?t.ORDER_NUMBER : -1,
            TEXT_CODE: t.TEXT_CODE,
            TEXT_TYPE:t.TEXT_TYPE,
            TEXT_CONTEXT:t.TEXT_CONTEXT,
            SORT_INDEX:t.SORT_INDEX,
            DESTINATION:null
        }
    });
    let orderInstructions =[];
    if (cmd == Command.Create){
        orderInstructions=state.instructions.map(i=>{
            return{
            ORDER_NUMBER: -1,
            DESTINATION: null,
            INSTRUCTION_CODE: i.INSTRUCTION_CODE,
            PRIORITY_KEY: i.PRIORITY_KEY,
            SORT_INDEX: i.SORT_INDEX,
            INSTRUCTION_TYPE: i.INSTRUCTION_TYPE
        }})
    } else{
        let instr = [];
        if(state.selectedEndUserValue.value.CLIENT_CODE_REGIONAL != state.oldEndUser){
            let oldInstr = state.oldInstructions.filter(i=>i.INSTRUCTION_TYPE == 0);
            let euInstr = state.instructions.filter(i=>i.INSTRUCTION_TYPE == 1);

            euInstr.forEach(e=>
                oldInstr.forEach(t=>{
                    if(t.INSTRUCTION_CODE === e.INSTRUCTION_CODE)
                        oldInstr.splice(oldInstr.indexOf(t),1);
                    }
                )
            );
            instr = oldInstr.concat(euInstr);
        } else{
            instr = state.oldInstructions;
        }
        orderInstructions=instr.map(i=>{
            return{
            ORDER_NUMBER: cmd == Command.Modify ? i.ORDER_NUMBER : -1,
            DESTINATION: null,
            INSTRUCTION_CODE: i.INSTRUCTION_CODE,
            PRIORITY_KEY: i.PRIORITY_KEY,
            SORT_INDEX: i.SORT_INDEX,
            INSTRUCTION_TYPE: i.INSTRUCTION_TYPE
        }})
    }
    
    return {
        ORDER_NUMBER: cmd==Command.Modify ? id : -1,
        AGENT_COMMENT:state.commentValue,
        CUSTOMER_PO:state.customerPO,
        ORDER_STATUS:ORDER_STATUS_ACTIVE,
        //DELIVERY_CODE:state.selectedDeliveryCodeValue.value.value.CODE,
        COPIED_FROM_ORDER_NUMBER: state.copiedFromOrderNumber,
        DELIVERY_DESTINATION:state.deliveryDestinationValue,
        CONTACT_CODE_SOLD_TO:state.selectedSoldToValue.value.CLIENT_CODE_REGIONAL,
        CONTACT_CODE_SHIP_TO:state.selectedShipToValue.value.CLIENT_CODE_REGIONAL,
        CONTACT_CODE_BILL_TO:state.selectedBillToValue.value.CLIENT_CODE_REGIONAL,
        CLIENT_CODE_REGIONAL:state.selectedCustomerValue.value.CLIENT_CODE_REGIONAL,
        //CURRENCY_CODE:state.currencyValue,
        CURRENCY_VALUE:0,
        END_USER:state.selectedEndUserValue.value.CLIENT_CODE_REGIONAL,
        REGISTRATIONUSER:'CSMWEB',
        
        REGISTRATION_DATETIME:null,
        MODUSER:null,
        MODUSER_DATETIME: cmd==Command.Modify ? state.oldmodificationDateTime : '',
        CONFIRMATION_VERSION:null,
        CONFIRMATION_SENT:null,
        TYPE:'3',
        FORMAT_UNIT: state.formatUnitValue,
        CALL_OFF:state.callOffValue==true ? '1' : null,
        EXT_ORDER_NUMBER:'-1',
        SALES_AGENT_REF:state.salesAgentRef,
        MILL_CODE:state.orderItems.find(i=>true) && state.orderItems.find(i=>true).MILL_CODE,
        //CASH_DISCOUNT_CODE:state.selectedEndUserValue.value.CASH_DISCOUNT_CODE || state.selectedCustomerValue.value.CASH_DISCOUNT_CODE,
        Texts:orderTexts,
        Instructions:orderInstructions,
        OLD_END_USER:state.oldEndUser
    }   
}


export {createOrderHeaderFromState};